module.exports = __webpack_public_path__ + "static/website-icon-81641e525682b174b10777cd75ca620a.png";